import React, { useState, useEffect } from "react"
import Button from '@mui/material/Button'
import BotaoVoltar from "./common/botaoVoltar";
import DistVafCircularProgress from "./common/distVafCircularProgress";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from "react-router-dom";
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import $ from 'jquery'
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import {URL_API} from "../config/urls";
import fetchWithToken from '../config/UseFetchWithToken';

export default function Af() {

	const [dados, setDados] = useState([])
	const [mostrarModal, setMostrarModal] = useState(false)
	const [afAtual, setAfAtual] = useState(false)
	const [afAtualId, setAfAtualId] = useState(false)
	const [mostraMensagem, setMostrarMensagem] = useState(false)
	const [mensagem, setMensagem] = useState("")
	const [loader, setLoader]  = useState(true);
	let nav = useNavigate()
	
	useEffect(() => {
		setLoader(true)
		
		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

		fetchWithToken(`${URL_API}/api/v1/af/obterAf`,requestAuthorization)
			.then(_res => _res.json())
			.then(res => {
				setLoader(false)
				if (res === "") {
					this.resultado = "Não foi possível carregar os dados!"
				}
				else {
					setDados(res)
					$(document).ready(function () {
						setTimeout(function () {
							$('#tblDados').DataTable({
								columnDefs: [
									{ orderable: false, targets: 2 },
									{ orderable: false, targets: 3 },
									{ orderable: false, targets: 4 }
								],
								lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
								pageLength: 1000,
								order: [[1, 'asc']],
								language: {
									url: '/pt-BR.json'
								}
							});
						}, 100);
					});
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
	}, [])

	function alterarAf(e) {
		nav("/distvaf/editarAf/" + e);
		return null
	}

	function confirmarExclusao() {

		let token_keycloack = sessionStorage.getItem('token_keycloack');

		const opcoes = {
			method: 'DELETE',
			headers: { 'Content-Type': 'application/json',"Authorization": `Bearer ${token_keycloack}` }
		};
		fetchWithToken(`${URL_API}/api/v1/af/${afAtualId}`, opcoes)
			.then(res => res.text())
			.then(_res => {
				const newState = dados.filter(item => item.codigo !== afAtualId)
				setDados(newState)
				setMensagem("O registro foi excluído!")
				setMostrarMensagem(true)
			})
			.catch(_err => {
				alert("Ocorreu um erro: "+_err)
				console.error("Ocorreu um erro"+_err)
			});
		setMostrarModal(false)
		return null
	}

	function excluirAf(id, nome) {
		setAfAtualId(id)
		setAfAtual(nome)
		setMostrarModal(true)
		return null
	}

	function exibirHistorico(id) {
		nav("/distvaf/historicoAf/" + id);
		return null
	}

	function fecharMensagem() {
		setMostrarMensagem(false)
		return null
	}

	function fecharModal() {
		setMostrarModal(false)
		return null
	}

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					<Collapse in={mostraMensagem}>
						<Alert action={<IconButton aria-label="close" color="inherit" size="small" onClick={ () => fecharMensagem() }><CloseIcon fontSize="inherit" /></IconButton>} sx={{ mb: 2 }}>{mensagem}</Alert>
					</Collapse>
					<header className="main">
						<h2>DISTVAF - Cadastro de AF</h2>
					</header>
				</div>
			</div>
			<div className="row">
				<div className="col-6">
					<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/editarAf/0")}>Inserir nova AF</Button>
				</div>
				<div className="col-6">
					<BotaoVoltar />
				</div>
			</div>
			<div className="row">
				<div className="col-12">
				{(loader && <DistVafCircularProgress />)}
					<div className="margem-antes">
						<table id="tblDados" className="stripe row-border">
							<thead>
								<tr>
									<th>AF</th>
									<th>Responsável</th>
									<th>Email</th>
									<th className="botao"></th>
									<th className="botao"></th>
									<th className="botao"></th>
								</tr>
							</thead>
							<tbody>
								{dados.map(result => {
									return (
										<tr className="center" key={result.codigo}>
											<td>{result.nome}</td>
											<td>{result.responsavel}</td>
											<td>{result.email}</td>
											<td className="align-center">
												<Tooltip title="Histórico">
													<IconButton className="pad0" color="primary" onClick={ () => exibirHistorico(result.codigo) }>
														<AccessTimeFilledIcon />
													</IconButton>
												</Tooltip>
											</td>
											<td className="align-center">
												<IconButton className="pad0" color="primary" title="Editar" onClick={ () => alterarAf(result.codigo) }><EditIcon /></IconButton>
											</td>
											<td className="align-center">
												<IconButton className="pad0" color="error" title="Excluir" onClick={ () => excluirAf(result.codigo, result.nome) }><DeleteIcon /></IconButton>
											</td>
										</tr>
									);
								})
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<Dialog open={mostrarModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">Atenção</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Confirma a exclusão da AF {afAtual}?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button variant="contained" color="error" onClick={ () => confirmarExclusao()}>Confirmar</Button>
					<Button variant="contained" color="primary" onClick={ () => fecharModal()}>Cancelar</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}
